var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.10709 1.41766L2.66661 4.50825C2.70787 4.55804 2.75905 4.598 2.81663 4.6254C2.87422 4.6528 2.93686 4.66699 3.00024 4.66699C3.06363 4.66699 3.12626 4.6528 3.18385 4.6254C3.24144 4.598 3.29261 4.55804 3.33387 4.50825L5.89339 1.41766C6.13766 1.12266 5.93514 0.666992 5.55976 0.666992H0.439985C0.0646082 0.666992 -0.137912 1.12266 0.10709 1.41766Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f4cb58d5.svg";
export { ForwardRef as ReactComponent };